import { GraphFilters, GraphVertex } from '../types';
import getVertexType from './getVertexType';

const doesNotContain = (filterList: string[], value: string) =>
  filterList.indexOf(value) === -1;

const matchesPropertyFilters = (
  propertyFilters: GraphFilters['properties'],
  { properties }: GraphVertex
) => {
  let valid = true;
  Object.keys(propertyFilters).forEach((key: string) => {
    if (
      !valid ||
      !properties ||
      properties[key] === undefined ||
      properties[key] !== propertyFilters[key]
    ) {
      valid = false;
      return;
    }
  });
  return valid;
};

const filterVertex = (
  v: GraphVertex,
  { hiddenTypes, hiddenAccounts, hiddenNodes, properties }: GraphFilters
): boolean => {
  const accountName = v?.properties?.['tag.AccountName'] || 'unknown';
  const type = getVertexType(v);
  return (
    doesNotContain(hiddenTypes, type) &&
    doesNotContain(hiddenAccounts, accountName) &&
    doesNotContain(hiddenNodes, v.id) &&
    matchesPropertyFilters(properties, v)
  );
};

export default filterVertex;
